/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { line } from './constants';
const lineStyles = css({
  display: 'block',
  position: 'absolute',
  zIndex: 1,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  background: line.backgroundColor,
  content: '""',
  pointerEvents: 'none'
});
const edgeStyles = {
  top: css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: line.thickness,
    top: 'var(--local-line-offset)',
    right: 0,
    left: 0
  }),
  right: css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: line.thickness,
    top: 0,
    right: 'var(--local-line-offset)',
    bottom: 0
  }),
  bottom: css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: line.thickness,
    right: 0,
    bottom: 'var(--local-line-offset)',
    left: 0
  }),
  left: css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: line.thickness,
    top: 0,
    bottom: 0,
    left: 'var(--local-line-offset)'
  })
};

/**
 * __Drop indicator__
 *
 * A drop indicator is used to communicate the intended resting place of the draggable item. The orientation of the drop indicator should always match the direction of the content flow.
 */
export function DropIndicator({
  edge,
  gap = '0px'
}) {
  /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */
  const lineOffset = `calc(-0.5 * (${gap} + ${line.thickness}px))`;
  return jsx("div", {
    css: [lineStyles, edge && edgeStyles[edge]]
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    style: {
      '--local-line-offset': lineOffset
    }
  });
}

// This default export is intended for usage with React.lazy
export default DropIndicator;